import type { AxiosInstance } from "axios";
import {
  API_REQUEST_TIMEOUT_MS,
  attachPendingRequestTracking,
} from "./pendingRequests";
import { attachLockOverride } from "./lockOverride";

export const configureApiClient = (axiosInstance: AxiosInstance): AxiosInstance => {
  axiosInstance.defaults.timeout = API_REQUEST_TIMEOUT_MS;
  attachPendingRequestTracking(axiosInstance);
  attachLockOverride(axiosInstance);

  return axiosInstance;
};
